/* eslint-disable indent */
import styled from 'styled-components';
import { COLORS, newLayout } from '../../../../theme';
import resizeHorizontallyIcon from '../../../../images/col-drag-grey.svg';

export const StyledSortArrow = styled.div``;

export const StyledTableHeaderResizer = styled.div``;

export const StyledColumnHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: ${({ theme, narrow }) =>
    narrow ? `2px ${theme.spacing.s4}` : theme.spacing.s4};
  height: 100%;
  width: 100%;
  // Set line height to unify different column components height
  line-height: ${newLayout.spacing.m4};
  min-height: ${({ narrow }) => (narrow ? '36px' : '64px')};

  ${StyledSortArrow} {
    margin-left: auto;
    opacity: 0;
    transition: opacity 0.25s, background 0.25s;
    width: ${({ theme }) => theme.spacing.m2};
    height: ${({ theme }) => theme.spacing.m2};
    background: ${COLORS.black08};
  }

  &:hover ${StyledSortArrow} {
    opacity: 1;
  }

  ${({ isOpen }) =>
    isOpen &&
    `
    background-color: ${COLORS.oceanGreenLight};

    ${StyledSortArrow} {
      opacity: 1;
      background: transparent;
    }

    &::before,
    &::after {
      position: absolute;
      left: -1px;
      right: -1px;
      height: 1px;
      background-color: ${COLORS.oceanGreen};
      content: '';
    }

    &::before {
      top: -1px;
    }

    &::after {
      bottom: -1px;
    }
  `}

  &:hover {
    ${StyledTableHeaderResizer} {
      display: inline-block;
      background: url(${resizeHorizontallyIcon}) no-repeat center center;
      width: ${newLayout.spacing.m2};
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      transform: translateX(50%);
      z-index: 1;
      touch-action: none;
    }
  }
`;
